import React from 'react';
import { Form, FormItem, Select, SubmitButton } from 'formik-antd';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'antd';
import Yup from '../../../../vendor/yup';
import IntlMessages from '../../../../layout/components/lang/IntlMessages';
import makeSelectFilterOption from '../../../../lib/makeSelectFilterOption';
import makeSelectFilterSort from '../../../../lib/makeSelectFilterSort';



const { Option } = Select;


const validationSchema = Yup.object().shape({
  roles_ids: Yup.array().of(Yup.number())
    .min(1, 'Required to specify at least 1 role')
    .required('Role field is required'),
});


const FormEditUserRoles = ({
  onSubmit,
  onCancel,
  initialValues,
  formErrors,
  isSubmitting,
  rolesList,
}) => {
  return (
    <Formik
      enableReinitialize
      validationSchema={validationSchema}
      isSubmitting={isSubmitting}
      initialValues={initialValues}
      initialErrors={formErrors}
      onSubmit={onSubmit}
    >
      {(props) => {
        // eslint-disable-next-line react/prop-types
        const { values, isValid, dirty } = props;

        return (
          <Form layout="vertical" className='w-full'>
            <FormItem
              name='roles_ids'
              label={<IntlMessages id="ui-general-roles" />}
              required
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                name="roles_ids"
                className='w-full'
                placeholder={<IntlMessages id='form-create-user-roles-placeholder' />}
                value={values.roles_ids}
                optionFilterProp="children"
                filterOption={(input, option) => makeSelectFilterOption(option.children, input)}
                filterSort={(optionA, optionB) => makeSelectFilterSort(optionA, optionB)}
              >
                {rolesList.map((role) => (
                  <Option key={role.id} value={role.id}>
                    {role.name}
                  </Option>
                ))}
              </Select>
            </FormItem>

            <Row gutter={[ 16, 16 ]} className='centered-item'>
              <Col>
                <Button
                  type='secondary'
                  onClick={onCancel}
                >
                  <IntlMessages id='ui-general-cancel' />
                </Button>
              </Col>

              <Col>
                <SubmitButton
                  loading={isSubmitting}
                  disabled={!isValid || !dirty}
                >
                  <IntlMessages id='ui-general-submit' />
                </SubmitButton>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

FormEditUserRoles.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  formErrors: PropTypes.object,
  values: PropTypes.shape({
    roles_ids: PropTypes.array,
  }),
  rolesList: PropTypes.array,
  isSubmitting: PropTypes.bool.isRequired,
};

FormEditUserRoles.defaultProps = {
  formErrors: {},
  values: {
    roles_ids: [],
  },
  rolesList: [],
};

export default FormEditUserRoles;
